import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Accordion from 'components/atoms/Accordions/Accordion/Accordion';
import FormStyles from 'styles/mixins/Form.styles';

const StyledTableViewsContent = styled(Accordion)`
  &::before {
    height: 0;
    background-color: unset;
  }
  
  .AccordionSummary {
    .MuiAccordionSummary-content {
      align-items: center;
      gap: ${props => props.theme.layout('0.5sp')};
      
      > .Typography {
        flex-grow: 1;
        width: 1px;
        font-size: ${props => props.theme.fontSize(15)};
        
        &, * {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .Chip {
        height: ${props => props.theme.layout(21.5)};
        white-space: nowrap;
        min-width: fit-content;
      }
      
      > .Span:has(.Chip) {
        display: none !important;
      }
      &:hover {
        > .Span:has(.Chip) {
          display: inline-flex !important;
        }
      }
    }
    
    &:not(.Mui-expanded) {
      .Badge .MuiBadge-badge {
        color: ${props => props.theme.property('palette.text.primary')};
        background-color: ${props => props.theme.property('palette.primary.states.focusVisible')};
      }
    }
  }
  
  .AccordionDetails {
    margin: ${props => props.theme.layout('0.5sp')} 0;
    padding: ${props => props.theme.spacing(2)};
    background-color: ${props => props.theme.property('palette.primary.states.hover')};

    border-radius: ${props => props.theme.radius(1)};
    
    .TableViewsContent { 
      &-form {
        &.InlineForm {
          .MuiInputBase-root {
            background-color: ${props => props.theme.property('palette.background.paper')};
          }

          .Form-group-notification {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          
          .FormControl {
            &.FormField-name-notification {
              margin-top: ${props => props.theme.layout('-0.5sp')};
              margin-bottom: ${props => props.theme.layout('-0.5sp')};
            }
          }

          .FormControl-inlineLabel {
            > .InputLabel, > .FormLabel {
              min-width: ${props => props.theme.layout(80)};
              max-width: ${props => props.theme.layout(80)};
            }

            &:not(.FormControl-readOnly) {
              > .InputLabel, > .FormLabel {
                margin-top: ${props => props.theme.layout(7)};
              }

              &.CheckboxField {
                > .InputLabel, > .FormLabel {
                  margin-top: ${props => props.theme.layout(7)};
                }
              }

              &.SwitchField {
                > .InputLabel, > .FormLabel {
                  margin-top: ${props => props.theme.layout(5)};
                }
              }

              &.ListField {
                > .InputLabel, > .FormLabel {
                  margin-top: ${props => props.theme.layout(4)};
                }
              }
            }
          }
        }
      }
      
      &-footer {
        display: flex;
        align-items: center;
        white-space: nowrap;
        gap: ${props => props.theme.layout('0.5sp')};
        margin-top: ${props => props.theme.layout('2sp')};
        
        &-center {
          ${props => props.theme.font2Css('body2')};
          text-align: center;
          flex-grow: 1;
          
          &, .Span {
            overflow: hidden;
            white-space: normal;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: ${props => props.theme.fontSize(13)};
            line-height: ${props => props.theme.lineHeight('1.3f')};
          }
        }
        
        &-left, &-right {
          display: flex;
          gap: ${props => props.theme.layout('0.5sp')};
        }
      }
    }
  }
  
  ${FormStyles}
  ${ComponentStyles}
`;

StyledTableViewsContent.propTypes = {
  theme: PropTypes.object
};

export default StyledTableViewsContent;
